module.exports = __webpack_public_path__ + "img/email.dec0c22c.svg";